import { z } from 'zod';

const defaultBooleanSchema = z.boolean().catch(false);

export const featureSetSchema = z.object({
    'ai-chat': defaultBooleanSchema,
    'announcements-enabled': defaultBooleanSchema,
    'alignment-dialogue': defaultBooleanSchema,
    'dashboard-v2': defaultBooleanSchema,
    'demo-menu': defaultBooleanSchema,
    'generate-all-job-roles': defaultBooleanSchema,
    'installation-guide': defaultBooleanSchema,
    'job-architecture-extension': defaultBooleanSchema,
    'job-architecture-v-2': defaultBooleanSchema,
    'jsa-generation-v-2': defaultBooleanSchema,
    'jsa-review-mode': defaultBooleanSchema,
    'languages-organization-settings': defaultBooleanSchema,
    'new-dashboard': defaultBooleanSchema,
    'new-learning-opportunities': defaultBooleanSchema,
    'position-management': defaultBooleanSchema,
    'review-status-table': defaultBooleanSchema,
    'show-deployed-version': defaultBooleanSchema,
    'simplified-settings-visibility': defaultBooleanSchema,
    'skills-section': defaultBooleanSchema,
    'terminology-settings': defaultBooleanSchema,
    'generate-all-families-clusters-roles-button': defaultBooleanSchema,
});

export type FeatureSet = z.infer<typeof featureSetSchema>;
export type FeatureName = keyof typeof featureSetSchema.shape;

export type FeatureFlagService = {
    readonly initialize: (userId: string) => Promise<void>;
    readonly isFeatureFlagEnabled: (featureFlagName: FeatureName) => boolean;
    readonly isInitialized: () => Promise<boolean>;
};
